import {Area} from 'react-easy-crop';

import {createImage} from './createImage';
import {getRadianAngle} from './getRadianAngle';
import {rotateSize} from './rotateSize';

const imageType = 'image/jpeg';

export const getCroppedImage = async (
  imageSrc: string,
  pixelCrop: Area,
  rotation = 0,
  originalFileName: string,
  fillColor: string
) => {
  const image = await createImage(imageSrc);
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  const fileName = originalFileName ?? 'cropped-image.jpeg';

  if (!ctx) {
    return null;
  }

  const rotRad = getRadianAngle(rotation);

  // calculate bounding box of the rotated image
  const {width: bBoxWidth, height: bBoxHeight} = rotateSize(image.width, image.height, rotation);

  // set canvas size to match the bounding box
  canvas.width = bBoxWidth;
  canvas.height = bBoxHeight;

  // translate canvas context to a central location to allow rotating and flipping around the center
  ctx.translate(bBoxWidth / 2, bBoxHeight / 2);
  ctx.rotate(rotRad);
  ctx.translate(-image.width / 2, -image.height / 2);

  // draw rotated image
  ctx.drawImage(image, 0, 0);

  const croppedCanvas = document.createElement('canvas');

  const croppedCtx = croppedCanvas.getContext('2d');

  if (!croppedCtx) {
    return null;
  }

  if (!pixelCrop) {
    return null;
  }

  // Set the size of the cropped canvas
  croppedCanvas.width = pixelCrop.width;
  croppedCanvas.height = pixelCrop.height;

  croppedCtx.fillStyle = fillColor;
  croppedCtx.fillRect(0, 0, croppedCanvas.width, croppedCanvas.height);

  // Draw the cropped image onto the new canvas
  croppedCtx.drawImage(
    canvas,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    pixelCrop.width,
    pixelCrop.height
  );

  // As Base64 string
  // return croppedCanvas.toDataURL('image/jpeg');

  // As a blob
  return new Promise<File | null>((resolve) => {
    croppedCanvas.toBlob((file) => {
      if (file) {
        resolve(new File([file], fileName, {type: imageType}));
      } else {
        resolve(null);
      }
    }, imageType);
  });
};
